<template>
  <v-container
    class="employee-card"
    :class="{ 'ma-0': noSpacing }"
  >
    <v-row class="pa-0 ma-0">
      <v-col class="pa-0 ma-0">
        <span class="name">{{ value.name }}</span>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-progress-circular
              v-on="on"
              :color="getStatus(value.status).color"
              :value="100"
              :size="9"
              class="ml-1"
            ></v-progress-circular>
          </template>
          <span>
            {{ getStatus(value.status).title }}
          </span>
        </v-tooltip>
        <p class="categories">
          {{ getCatNames(value.categories) }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  props: {
    value: {
      type: Object,
      required: true
    },
    noSpacing: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getStatus (status) {
      return (this.get_global.defaults.options.users.status && typeof this.get_global.defaults.options.users.status[status] !== 'undefined' ? this.get_global.defaults.options.users.status[status] : {})
    },
    getCatNames (cats) {
      let names = cats.map(e => e.name) || []
      return (names.length > 0 ? names.join(' / ') : this.lang.categories.new.all_cat)
    }
  }
}
</script>

<style lang="scss">
.employee-card {
  #app & {
    width: 100%;
    height: 47px;
    max-width: 150px !important;
    max-height: 47px;
    margin: 4px 0px;
    padding: 3.5px;
    border-radius: 3px;
    white-space: nowrap;
    .row {
      margin: 0px !important;
    }
    .name {
      white-space: nowrap;
      overflow: hidden;
      width: 95%;
      text-overflow: ellipsis;
      display: inline-block;
      margin-bottom: -5px;
    }
    .categories {
      font-size: 11px;
      width: auto;
      max-width: 150px !important;
      margin: 0px !important;
      overflow: hidden;
      white-space: nowrap;
      position: relative;
      text-overflow: ellipsis;
      transition: all 0.3s ease-in-out;
      &:hover {
        max-width: 100% !important;
        position: absolute !important;
        z-index: 1 !important;
        padding-right: 4px;
      }
    }
  }
  #app.theme--light & {
    .categories:hover {
      background: rgba(255, 255, 255, 0.5) !important;
    }
    background: linear-gradient(325deg,
      rgba(255,255,255,0.07) 0%,
      rgba(255,255,255,0.12) 30%,
      rgba(255,255,255,0.12) 50%,
      rgba(255,255,255,0.12) 70%,
      rgba(255,255,255,0.07) 100%
    );
    &:hover {
      background: rgba(255,255,255,0.15) !important;
    }
  }
  #app.theme--dark & {
    .categories:hover {
      background: rgba(0, 0, 0, 0.1) !important;
    }
    background: linear-gradient(325deg,
      rgba(0,0,0,0.07) 0%,
      rgba(0,0,0,0.2) 30%,
      rgba(0,0,0,0.2) 50%,
      rgba(0,0,0,0.2) 70%,
      rgba(0,0,0,0.07) 100%
    );
    &:hover {
      background: rgba(0,0,0,0.15) !important;
    }
  }
}
</style>
